import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=15b2fd34&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=js&"
export * from "./NavBar.vue?vue&type=script&lang=js&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=15b2fd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2fd34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b2fd34')) {
      api.createRecord('15b2fd34', component.options)
    } else {
      api.reload('15b2fd34', component.options)
    }
    module.hot.accept("./NavBar.vue?vue&type=template&id=15b2fd34&scoped=true&", function () {
      api.rerender('15b2fd34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/NavBar.vue"
export default component.exports